(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('collections-grid-component')) {
  class CollectionsGrid extends HTMLElement {
    connectedCallback() {
      if (this.dataset.layout !== 'scroll') return;
      this._track    = this.querySelector('[id^="cg-track-"]');
      this._prev     = this.querySelector('[id^="cg-prev-"]');
      this._next     = this.querySelector('[id^="cg-next-"]');
      this._progress = this.querySelector('[id^="cg-progress-"]');
      if (!this._track) return;
      this._prev?.addEventListener('click', () => this._move(-1));
      this._next?.addEventListener('click', () => this._move(1));
      this._track.addEventListener('scroll', () => this._sync(), { passive: true });
      this._sync();
    }
    _move(dir) {
      const card = this._track.querySelector('.collections-grid__card');
      if (!card) return;
      this._track.scrollBy({ left: dir * (card.offsetWidth + 16), behavior: 'smooth' });
    }
    _sync() {
      const { scrollLeft, scrollWidth, clientWidth } = this._track;
      const max = Math.max(1, scrollWidth - clientWidth);
      const pct = scrollLeft / max;
      if (this._progress) this._progress.style.transform = `scaleX(${Math.max(0.06, Math.min(1, pct))})`;
      if (this._prev) this._prev.disabled = scrollLeft < 2;
      if (this._next) this._next.disabled = scrollLeft >= max - 2;
    }
  }
  customElements.define('collections-grid-component', CollectionsGrid);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
